/* @flow-strict */

/* eslint-disable camelcase */
import * as React from 'react';
import { AssignEventPermission, QuestionDisplayType } from '/client/src/constants/';
import CssPinner from '/client/src/components/csspinner';
import { PUT } from '/client/src/api';
import { DefaultContainerContext } from '/client/src/contexts/defaultContainer';


export const getQuestion = (theEvent, ticket_id, question_id) => {
  const question = _.find(theEvent, q => _.toString(q.id) === _.toString(question_id));

  if (!!_.size(question)) {
    if (question.applied_to_ticket_id.indexOf(ticket_id) > -1) {
      return question;
    }
  }

  return null;
};

export const createDynamicColumn = (
  theEvent,
  dynamicColumns,
  qa_id,
  qa_text,
  editRow,
  rowsOrg,
  toggleEdit,
  setRowsOrg,
  isNeedShowConfirm,
  onHandleFindAndReplaceRowData,
  ValidateByEmpty,
  preSavedQuestionAnswers,
  setPreSavedQuestionAnswers
) => {
  const context = React.useContext(DefaultContainerContext);

  const qa_key = qa_id + qa_text.replace(/[^a-zA-Z0-9_-]/g, (substr) => {
    return `_${substr.charCodeAt(0)}`;
  });

  if (!dynamicColumns[qa_key]) {
    return {
      name: qa_text,
      className: `question-cols ${qa_key}`,
      selector: `[${qa_text.replace(' ', '+')}]`,
      sortable: true,
      cell: (row) => {
        const key = qa_key; // meta.settings.aoColumns[meta.col].qa_key;
        const questions = row.question_answers;

        let event_question = getQuestion(theEvent, row.ticket_id, qa_id);

        const question_answer = _.find(questions, (q) => {
          if (q.question) {
            const _Q = q.question_id + q.question.text.replace(/[^a-zA-Z0-9_-]/g, (substr) => {
              return `_${substr.charCodeAt(0)}`;
            });

            return _Q === key;
          }
          return false;
        });

        let value = '';

        let prev_value = '';

        if (question_answer) {
          value = question_answer.answers.join(',');

          if (question_answer._answers) {
            prev_value = question_answer._answers.join(',');
          }

          // If the current question is not available, use the question in the snapshot
          event_question = event_question || question_answer.question;
        } else if (event_question) {
          // If there is an answer in the current data,
          // the question ID is the same as the current question ID, but the text is different
          // Explain that this column is a column whose problem has been modified, then this column cannot be edited
          const qa = _.some(questions, (q) => {
            if (q.question) {
              return _.toString(q.question_id) === _.toString(event_question.id) &&
                q.question.text !== event_question.text;
            }

            return false;
          });

          if (qa || qa_text !== event_question.text) {
            event_question = null;
          }
        }
        // Read-only permission returns value directly
        if (theEvent.permission === AssignEventPermission.Read) {
          return value;
        }

        if (event_question) {
          let editor_cls = '';

          if (event_question.display_type === QuestionDisplayType.TextBox) {
            editor_cls = 'qtextbox';
          }
          if (event_question.display_type === QuestionDisplayType.Checkbox) {
            editor_cls = 'qcheckbox';
          }
          if (event_question.display_type === QuestionDisplayType.DropdownList) {
            editor_cls = 'qdropdown';
          }

          // Question plus q_ to avoid loss of digital precision
          // return value;

          const preSavedId = event_question.id + row.id;
          const preSavedQuestionAnswer = preSavedQuestionAnswers.find(x => x.id === preSavedId);

          if (preSavedQuestionAnswer) {
               value = preSavedQuestionAnswer.value;
          }

          const [answerValue, setAnswerValue] = React.useState(value || '');

          return (
            <div className={`editor ${editor_cls}`} data-id={`q_${event_question.id}`} data-title={`${qa_text}`}>
            {preSavedId !== _.get(editRow, 'preSavedId', 0) ?
              <>
                <span className="value">{value} &nbsp;</span>
                <i
                  className="icon icon-pencil"
                  style={{
                    color: '#e22853',
                    fontSize: '16px'
                  }}
                  onClick={() => {
                    if (_.size(editRow) && _.size(rowsOrg) && isNeedShowConfirm(editRow, rowsOrg)) {
                      // trigger open confirm modal when click in the same handler
                      $('body').click();
                    }

                    if (!_.size(editRow) && !_.size(rowsOrg) || !isNeedShowConfirm(editRow, rowsOrg)) {
                      const _row = _.clone(row);

                      toggleEdit({ ...row, preSavedId });
                      setRowsOrg(_row);
                    }
                  }}
                />
              </>
              :
              <>
                <input
                  type="text"
                  placeholder={event_question.text}
                  value={answerValue}
                  style={{
                    border: '1px solid #cecece',
                    borderRadius: '4px',
                    lineHeight: '20px',
                    padding: '4px .5rem',
                    width: '100%',
                    marginRight: '5px'
                  }}
                  onChange={(e: any) => {
                    setAnswerValue(e.target.value);
                  }}
                />
                <i
                  className="icon icon-save"
                  style={{
                    color: '#e22853',
                    fontSize: '16px'
                  }}
                  onClick={async () => {
                    const isValid = ValidateByEmpty();

                    if (_.isString(isValid)) {
                      context.handleShowSystemDialog(true, {
                        systemDialogType: 'error',
                        systemDialogTitle: 'Oops',
                        systemDialogContent: isValid
                      });
                    } else {
                      CssPinner(document.body, true);

                      try {
                        await PUT(`/api/v1/1/events/${row.event_id}/attendee/${row.id}/question/${event_question.id}`, {
                          question_answers: [answerValue]
                        });
                        const newArray = preSavedQuestionAnswers;
                        const preSavedIndex = preSavedQuestionAnswers.findIndex(x => x.id === preSavedId);

                        if (preSavedIndex > -1) {
                          newArray[preSavedIndex] = { value: answerValue, id: preSavedId };
                        } else {
                          newArray.push({ value: answerValue, id: preSavedId });
                        }
                        setPreSavedQuestionAnswers(newArray);
                      } catch (e) {
                        console.error(e);
                        context.handleShowSystemDialog(true, {
                          systemDialogType: 'error',
                          systemDialogTitle: 'Oops',
                          systemDialogContent: 'Can\'t save'
                        });
                      }

                      CssPinner(document.body, false);
                      toggleEdit(null);
                      setRowsOrg({});
                    }
                  }}
                />
              </>
            }
            </div>
          );
        }

        return <div className="no-control">/</div>;
      }
    };
  }
};
